import React, { useEffect, useState } from 'react';
import { Form, Select, Input } from 'udesk-ui';
import styled from 'styled-components';
import { UserTagsSelect as UserTagsSelectV2 } from 'Component/pages/components/coach/UserTagsSelect-v2';
import { useCustomerPortraitConfigContext } from '../Context';

const StyledFormWrapper = styled.div`
    .udesk-qa-ui-form-item:last-child {
        margin-bottom: 0;
    }
`;

const InternalCustomerPortraitList = React.memo<any>((props) => {
    const { onChange, value, allCustomerPortrait, handleOriginalUserTags } = props;

    return (
        <StyledFormWrapper>
            <Form.Item>
                <Select showSearch optionFilterProp="label" value={value} onChange={onChange}>
                    {allCustomerPortrait.map((item) => {
                        return (
                            <Select.Option value={item.id!} label={item.name}>
                                {item.name}
                            </Select.Option>
                        );
                    })}
                </Select>
            </Form.Item>
            {value?.length > 0 && (
                <>
                    <Form.Item name="userTag" label="角色标签">
                        <UserTagsSelectV2 handleOriginalNodes={handleOriginalUserTags} />
                    </Form.Item>
                    <Form.Item name="useDesc" label="角色描述">
                        <Input.TextArea />
                    </Form.Item>
                    <Form.Item name="customerTags" hidden></Form.Item>
                </>
            )}
        </StyledFormWrapper>
    );
});

const useCustomerPortraitList = (needRefresh?) => {
    const { allCustomerPortrait, batchBindFlow, flowId } = useCustomerPortraitConfigContext();
    const [selectedIds, setSelectedIds] = useState<number[]>([]);

    useEffect(() => {
        setSelectedIds(
            allCustomerPortrait.filter((p) => p.bindFlowIds?.includes(flowId)).map((i) => i.id!)
        );
    }, [allCustomerPortrait, flowId, needRefresh]);
    const onSelect = (id, selected) => {
        if (selected) {
            setSelectedIds((selectedIds) => selectedIds.concat([id]));
            // propsOnChange?.(selectedIds.concat([id]));
        } else {
            setSelectedIds((selectedIds) => selectedIds.filter((i) => i !== id));
            // propsOnChange?.(selectedIds.filter((i) => i !== id));
        }
    };
    return {
        onChange: onSelect,
        value: selectedIds,
        allCustomerPortrait,
        batchBindFlow,
    };
};

type CustomerPortraitListType = typeof InternalCustomerPortraitList & {
    useCustomerPortraitList: typeof useCustomerPortraitList;
};

const CustomerPortraitList: CustomerPortraitListType =
    InternalCustomerPortraitList as CustomerPortraitListType;

CustomerPortraitList.useCustomerPortraitList = useCustomerPortraitList;

export { CustomerPortraitList };
